<template>
  <div class="joinContent">
    <img :src="data.style.image.indexOf('http')==-1?info.picdomain+data.style.image:data.style.image" alt="">
    <div :style="'color:'+data.style.color">{{data.params.title}}</div>
  </div>
</template>

<script>
import store from '@/store'
export default {
props:{data:Object},
setup(){


  return{
     info: store.state.user.info
  }
}
}
</script>

<style lang="less" scoped>
.joinContent{
  width: 80px;
  font-size: 12px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  img{
    width: 100%;
  }
}
</style>